import { render, staticRenderFns } from "./ArchiveBulkPaymentsModal.vue?vue&type=template&id=00d2c422&"
import script from "./ArchiveBulkPaymentsModal.vue?vue&type=script&lang=js&"
export * from "./ArchiveBulkPaymentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ArchiveBulkPaymentsModal.vue"
export default component.exports